var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 390,
    viewBox: "0 0 148 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-67.3499 212.643C-65.4717 215.412 -62.751 217.476 -59.6623 218.454L78.4771 261.571C66.7598 285.697 47.8737 304.908 24.4201 316.556C0.966484 328.205 -25.9007 331.718 -52.481 326.613L-68.5673 323.203L-30.579 389.001L-27.5904 389.078C2.24729 389.501 31.2493 382.499 57.0107 368.651C82.7722 354.803 104.551 334.509 120.541 309.452L121.008 308.691C128.197 297.184 134.116 284.814 138.662 271.794C142.338 259.701 145.282 247.333 147.478 234.758C148.123 231.351 147.481 227.725 145.684 224.612C143.886 221.499 141.067 219.13 137.795 217.986L-2.85132 174.837L30.1036 31.4591C30.7482 28.0529 30.107 24.4268 28.3096 21.3135C26.5121 18.2003 23.6924 15.8319 20.4203 14.6871C8.4319 10.3013 -3.7517 6.66676 -16.0622 3.80367C-29.6106 1.23091 -43.2832 0.171651 -56.8428 0.644317L-57.7351 0.668001C-87.4308 1.98711 -115.895 10.701 -140.769 26.0873C-165.642 41.4735 -186.207 63.0887 -200.759 89.1407L-202.187 91.7673L-164.199 157.565L-159.108 141.929C-150.239 116.357 -133.763 94.8461 -111.948 80.359C-90.1338 65.8718 -64.054 59.1212 -37.3011 61.037L-69.0307 202.228C-69.7283 205.391 -69.3005 208.78 -67.8422 211.791L-67.8767 211.811C-67.7932 211.953 -67.7075 212.093 -67.6197 212.232C-67.5437 212.377 -67.4653 212.52 -67.3845 212.663L-67.3499 212.643Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.ae2d747e30bea383e170d7e7b12a779b.svg";
export { ForwardRef as ReactComponent };